export async function getMediaType(url?: string): Promise<'image' | 'video' | null> {
  if (!url) return null
  try {
    // Check for handlebars pattern
    if (url.includes('{{') && url.includes('}}')) {
      return 'image'
    }

    // Check for common media file extensions in the URL
    const imagePattern = /\.(jpeg|jpg|gif|png|webp|svg|bmp|ico|tif|tiff)(\?.*)?$/i
    const videoPattern = /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)(\?.*)?$/i

    if (imagePattern.test(url)) {
      return 'image'
    } else if (videoPattern.test(url)) {
      return 'video'
    }

    // If no extension matched, make a HEAD request to determine the content type
    const response = await fetch(url, { method: 'HEAD' })
    if (response.ok) {
      const contentType = response.headers.get('Content-Type')
      if (contentType?.startsWith('image/')) {
        return 'image'
      } else if (contentType?.startsWith('video/')) {
        return 'video'
      }
    }
    return 'image'
  } catch (error) {
    console.error('Error fetching media type:', error)
    return 'image'
  }
}
